module.exports = __webpack_public_path__ + "static/talkbox-team-e090d150cf07c71766f912cb6168ba4e.png";